export const JCA_FILTERS = [
  {
    name: 'estado',
    comboId: 'estados_jca',
    multiple: true,
  },
  {
    name: 'tipo_instalacion',
    comboId: 'tipo_instalacion',
    multiple: true,
  },
  {
    name: 'situacion_suministro',
    comboId: 'situacion_suministro',
    multiple: true,
  },
  {
    name: 'gremio_ip_id',
    comboId: 'gremios_ip',
    multiple: true,
  },
  {
    name: 'fecha_creacion_inicio',
    filterType: 'date',
    maxDateField: 'fecha_creacion_fin',
  },
  {
    name: 'fecha_creacion_fin',
    filterType: 'date',
    minDateField: 'fecha_creacion_inicio',
  },
  {
    name: 'fecha_jca_inicio',
    filterType: 'date',
    maxDateField: 'fecha_jca_fin',
  },
  {
    name: 'fecha_jca_fin',
    filterType: 'date',
    minDateField: 'fecha_jca_inicio',
  },
]
